import { FC } from 'react';
import * as Switch from '@radix-ui/react-switch';
import { cn, useNextGenUiCookie } from '@fe-learner-common';
import { useConfigContext } from '@fe-core';

interface TagProps {
  className?: string;
  children: string;
}

const Tag: FC<TagProps> = ({ className, children }) => {
  return (
    <span
      className={cn(
        className,
        'lf:rounded-sm lf:bg-positive-500 lf:px-1 lf:text-body-sm lf:font-medium lf:text-neutral-0',
      )}
    >
      {children}
    </span>
  );
};

export const NextGenUiToggle = ({
  isLoading,
  onChange,
  texts,
}: {
  isLoading: boolean;
  onChange?: (enabled: boolean) => void;
  texts: {
    label: string;
    description: string;
    beta: string;
  };
}) => {
  const { config } = useConfigContext();
  const { enabled, enableNextGenUi, disableNextGenUi } = useNextGenUiCookie();

  const handleToggle = () => {
    if (enabled) {
      onChange?.(enabled);
      disableNextGenUi();
    } else {
      enableNextGenUi();
    }
  };

  if (config.webfeatures?.['nextgenui-default']) {
    return null;
  }

  return (
    // eslint-disable-next-line tailwindcss/no-custom-classname
    <div className="next-gen-ui-toggle lf:flex lf:h-10 lf:shrink-0  lf:items-center lf:justify-center lf:bg-prominence-50 lf:px-4 lf:py-1">
      {!isLoading && (
        <form>
          <div className="lf:flex lf:items-center lf:justify-center">
            <Switch.Root
              onCheckedChange={handleToggle}
              checked={enabled}
              className="lf:relative lf:h-[20px] lf:w-[28px] lf:rounded-full lf:bg-neutral-300 lf:outline-offset-2 lf:data-[state=checked]:bg-prominence-500"
              id="next-gen-ui-switch"
            >
              <Switch.Thumb className="lf:block lf:h-[16px] lf:w-[16px] lf:rounded-full lf:bg-neutral-0 lf:transition-transform lf:duration-100 lf:will-change-transform lf:ltr:translate-x-0.5 lf:ltr:data-[state=checked]:translate-x-[10px] lf:rtl:translate-x-[-2px] lf:rtl:data-[state=checked]:translate-x-[-10px]" />
            </Switch.Root>
            <label
              className="lf:flex lf:cursor-pointer lf:items-center lf:leading-none"
              htmlFor="next-gen-ui-switch"
            >
              <p className="lf:ms-2 lf:text-label-lg">{texts.label}</p>
              <p className="lf:ms-2 lf:hidden lf:text-body-md lf:md:block">
                {texts.description}
              </p>
              <Tag className="lf:ms-2">{texts.beta}</Tag>
            </label>
          </div>
        </form>
      )}
    </div>
  );
};
